import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import PageSeo from '../components/PageSeo';
import { SEO } from '../utils/seoConfig';

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-[#F5F5F5] py-12">
      <PageSeo {...SEO.cookiePolicy} />
      <div className="container mx-auto px-4 max-w-4xl">
        <Card>
          <CardContent className="p-8">
            <h1 className="text-3xl font-bold text-[#0A2540] mb-6">
              Politique de Cookies
            </h1>

            <div className="space-y-6 text-gray-700">
              {/* Introduction */}
              <section>
                <h2 className="text-xl font-bold text-[#0A2540] mb-3">
                  Qu'est-ce qu'un cookie ?
                </h2>
                <p className="text-sm leading-relaxed">
                  Un cookie est un petit fichier texte déposé sur votre appareil lors de la visite d'un site web. 
                  Il permet au site de mémoriser certaines informations sur votre visite, comme vos préférences de langue 
                  et d'autres paramètres, afin de faciliter votre prochaine visite et de rendre le site plus utile.
                </p>
              </section>

              {/* Types de cookies */}
              <section>
                <h2 className="text-xl font-bold text-[#0A2540] mb-3">
                  Types de cookies utilisés
                </h2>
                
                <div className="space-y-4">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#0A2540] mb-2">Cookies essentiels</h3>
                    <p className="text-sm">
                      Ces cookies sont nécessaires au fonctionnement du site. Ils permettent l'authentification, 
                      la gestion de votre panier et la sécurité de votre navigation.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#0A2540] mb-2">Cookies de performance</h3>
                    <p className="text-sm">
                      Ces cookies nous aident à comprendre comment les visiteurs interagissent avec notre site 
                      en collectant des informations de manière anonyme. Nous utilisons PostHog pour l'analyse.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#0A2540] mb-2">Cookies de préférence</h3>
                    <p className="text-sm">
                      Ces cookies mémorisent vos choix (langue, devise, région) pour vous offrir une expérience 
                      personnalisée.
                    </p>
                  </div>
                </div>
              </section>

              {/* Durée de conservation */}
              <section>
                <h2 className="text-xl font-bold text-[#0A2540] mb-3">
                  Durée de conservation
                </h2>
                <ul className="list-disc pl-5 text-sm space-y-1">
                  <li>Cookies de session : supprimés à la fermeture du navigateur</li>
                  <li>Cookies persistants : conservés jusqu'à 12 mois maximum</li>
                  <li>Cookies d'analyse (PostHog) : 12 mois</li>
                </ul>
              </section>

              {/* Gestion des cookies */}
              <section>
                <h2 className="text-xl font-bold text-[#0A2540] mb-3">
                  Gérer vos préférences
                </h2>
                <p className="text-sm mb-4">
                  Vous pouvez à tout moment modifier vos préférences de cookies via les paramètres de votre navigateur :
                </p>
                <ul className="list-disc pl-5 text-sm space-y-1">
                  <li><strong>Chrome :</strong> Paramètres → Confidentialité et sécurité → Cookies</li>
                  <li><strong>Firefox :</strong> Options → Vie privée et sécurité → Cookies</li>
                  <li><strong>Safari :</strong> Préférences → Confidentialité</li>
                  <li><strong>Edge :</strong> Paramètres → Cookies et autorisations de site</li>
                </ul>
                <p className="text-sm mt-4 text-gray-500">
                  Note : La désactivation de certains cookies peut affecter le fonctionnement du site.
                </p>
              </section>

              {/* Liste détaillée */}
              <section>
                <h2 className="text-xl font-bold text-[#0A2540] mb-3">
                  Liste des cookies utilisés
                </h2>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm border">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="text-left p-3 border-b">Nom</th>
                        <th className="text-left p-3 border-b">Finalité</th>
                        <th className="text-left p-3 border-b">Durée</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="p-3 border-b">user, token</td>
                        <td className="p-3 border-b">Authentification</td>
                        <td className="p-3 border-b">Session</td>
                      </tr>
                      <tr>
                        <td className="p-3 border-b">cart</td>
                        <td className="p-3 border-b">Panier d'achat</td>
                        <td className="p-3 border-b">7 jours</td>
                      </tr>
                      <tr>
                        <td className="p-3 border-b">i18next</td>
                        <td className="p-3 border-b">Préférence de langue</td>
                        <td className="p-3 border-b">1 an</td>
                      </tr>
                      <tr>
                        <td className="p-3 border-b">cookie_consent</td>
                        <td className="p-3 border-b">Consentement cookies</td>
                        <td className="p-3 border-b">1 an</td>
                      </tr>
                      <tr>
                        <td className="p-3 border-b">ph_*</td>
                        <td className="p-3 border-b">Analyse (PostHog)</td>
                        <td className="p-3 border-b">1 an</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              {/* Contact */}
              <section>
                <h2 className="text-xl font-bold text-[#0A2540] mb-3">
                  Contact
                </h2>
                <p className="text-sm">
                  Pour toute question concernant notre politique de cookies, contactez-nous :
                </p>
                <ul className="list-none mt-2 text-sm space-y-1">
                  <li>Email : contact@geots.consulting</li>
                  <li>Adresse : 26 Rue des Rigoles, 75020 Paris</li>
                </ul>
              </section>

              {/* Mise à jour */}
              <section className="pt-4 border-t">
                <p className="text-xs text-gray-500">
                  Dernière mise à jour : Avril 2025
                </p>
              </section>
            </div>

            {/* Retour */}
            <div className="mt-8 pt-6 border-t">
              <Link to="/" className="text-[#635BFF] hover:underline font-medium">
                ← Retour à l'accueil
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
